import React from "react";
import DemoPublicShell from "../../components/demo/DemoPublicShell";
import GuidedTour from "../../features/guided-tour/GuidedTour";

const TryContractPage = () => (
  <DemoPublicShell>
    <GuidedTour />
  </DemoPublicShell>
);

export default TryContractPage;
